export default __webpack_public_path__ + "static/media/waitlist.3815460b.svg";